// extracted by mini-css-extract-plugin
export default {"passwordConfirmWrapper":"passwordconfirm_passwordConfirmWrapper__orkOL","passwordConfirmContainer":"passwordconfirm_passwordConfirmContainer__eDYXb"};